import React, { useState } from "react";
import Box from "@mui/material/Box";
import { Grid, Button, Chip } from "@material-ui/core";
import styles from "../setting.module.css";
import Avatar from "@mui/material/Avatar";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import useAxiosPrivate from "../../../utils/hooks/useAxiosPrivate";

export default function CoachManagementModalForSuperAdmin(props) {
  const { data, loadData, setDisplayMessage } = props;
  const axios = useAxiosPrivate();
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });
  const [edit, setEdit] = useState(false);
  const [removeId, serRemoveId] = useState(null);

  const handleClose = () => {
    setAlert({
      showAlert: false,
      severity: "success",
      message: "",
    });
  };

  const handleRemove = (e) => {
    serRemoveId(e?.id);
    setEdit(true);
  };

  const handleCancel = (e) => {
    serRemoveId(null);
    setEdit(false);
  };

  const submitAction = async (e, role) => {
    try {
      const { data } = await axios.post("/team/change_role", {
        user_id: e?.id,
        role: role,
      });
      if (data?.status === "OK") {
        setAlert({
          showAlert: true,
          severity: "success",
          message: data?.message,
        });

        if (role === "ADMIN") {
          setDisplayMessage({
            show: true,
            message: `${e.first_name ?? "-"} ${
              e.last_name ?? "-"
            } has been upgraded to Admin.`,
          });
        } else {
          setDisplayMessage({
            show: true,
            message: `${e.first_name ?? "-"} ${
              e.last_name ?? "-"
            } has been Changed to ${role}.`,
          });
        }
      }
      loadData();
    } catch (error) {
      if (error.response && error.response?.data) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: error.response?.data?.message,
        });
      } else {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Something error!",
        });
      }
    }
  };

  const submitRemoveAction = async (e) => {
    try {
      const { data } = await axios.delete(`/team/admins/${e?.id}`);
      if (data?.status === "OK") {
        setAlert({
          showAlert: true,
          severity: "success",
          message: data?.message,
        });
        setDisplayMessage({
          show: true,
          message: `${e.first_name} ${e.last_name} has been removed.`,
        });
      }
      loadData();
    } catch (error) {
      if (error.response && error.response?.data) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: error.response?.data?.message,
        });
      } else {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Something error!",
        });
      }
    }
  };

  return (
    <>
      <Grid
        container
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid container style={{ width: "60.5rem" }}>
          <Grid
            item
            md={3}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <p className={styles.tittleText}>Name</p>
          </Grid>
          <Grid
            item
            md={4}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <p className={styles.tittleText}>Email</p>
          </Grid>
          <Grid
            item
            md={2}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <p className={styles.tittleText}>Level</p>
          </Grid>
          <Grid
            item
            md={2}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <p className={styles.tittleText}>Operation</p>
          </Grid>
          <Grid
            item
            md={1}
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            <p className={styles.tittleText}></p>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box className={styles.boxCSSForSuperAdmin}>
          {data.map((item) => (
            <>
              <Grid container style={{ marginTop: "1rem" }}>
                <Grid
                  item
                  md={1}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Avatar
                    alt="Rem_Sharp"
                    src={item.avatar_url}
                    sx={{ width: 35, height: 35 }}
                  />
                </Grid>
                <Grid
                  item
                  md={2}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <Grid container>
                    <Grid
                      item
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "flex-end",
                      }}
                    >
                      <p className={styles.tittleTextData1}>
                        {item?.first_name ?? "-"}
                      </p>
                    </Grid>
                    <Grid
                      item
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                      }}
                    >
                      <p className={styles.tittleTextData2}>
                        {item?.last_name}
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  md={4}
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <p className={styles.tittleTextData}>{item?.email}</p>
                </Grid>
                <Grid
                  item
                  md={2}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Chip
                    label={
                      item?.role === "SUPER_ADMIN"
                        ? "Super Admin"
                        : item?.role === "ADMIN"
                        ? "Admin"
                        : item?.role === "USER_PHYSICIAN"
                        ? "Physician"
                        : item?.role === "USER_TECHNICIAN"
                        ? "Technician"
                        : "User"
                    }
                    size="small"
                    style={{
                      backgroundColor: "#A6DCE5",
                      padding: "0.5rem 0.5rem 0.5rem 0.5rem",
                    }}
                  />
                </Grid>

                {edit && removeId === item.id ? (
                  <Grid
                    item
                    md={2}
                    container
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      item
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        fullWidth
                        size="large"
                        onClick={() => submitRemoveAction(item)}
                        style={{
                          fontSize: "0.9rem",
                          lineHeight: "1.25rem",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontStyle: "normal",
                          width: 100,
                          height: 35,
                          backgroundColor: "#0F9BB0",
                          color: "white",
                          textTransform: "none",
                        }}
                      >
                        Remove
                      </Button>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid
                    item
                    md={2}
                    container
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      item
                      md={12}
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                      }}
                    >
                      {item?.role === "ADMIN" ? (
                        <div>
                          <p
                            className={styles.tittleTextOperation}
                            onClick={() => submitAction(item, "USER")}
                          >
                            Downgrade to User
                          </p>
                          <p
                            className={styles.tittleTextOperation}
                            onClick={() => submitAction(item, "SUPER_ADMIN")}
                          >
                            Upgrade to Super admin
                          </p>
                        </div>
                      ) : item?.role === "USER" ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <p
                            className={styles.tittleTextOperation}
                            onClick={() => submitAction(item, "ADMIN")}
                          >
                            Upgrade to Admin
                          </p>
                          <p
                            className={styles.tittleTextOperation}
                            onClick={() => submitAction(item, "USER_PHYSICIAN")}
                          >
                            Change to Physician
                          </p>
                          <p
                            className={styles.tittleTextOperation}
                            onClick={() =>
                              submitAction(item, "USER_TECHNICIAN")
                            }
                          >
                            Change to Technician
                          </p>
                        </div>
                      ) : item?.role === "USER_PHYSICIAN" ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <p
                            className={styles.tittleTextOperation}
                            onClick={() => submitAction(item, "ADMIN")}
                          >
                            Upgrade to Admin
                          </p>
                          <p
                            className={styles.tittleTextOperation}
                            onClick={() => submitAction(item, "USER")}
                          >
                            Change to User
                          </p>
                          <p
                            className={styles.tittleTextOperation}
                            onClick={() =>
                              submitAction(item, "USER_TECHNICIAN")
                            }
                          >
                            Change to Technician
                          </p>
                        </div>
                      ) : item?.role === "USER_TECHNICIAN" ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "5px",
                          }}
                        >
                          <p
                            className={styles.tittleTextOperation}
                            onClick={() => submitAction(item, "ADMIN")}
                          >
                            Upgrade to Admin
                          </p>
                          <p
                            className={styles.tittleTextOperation}
                            onClick={() => submitAction(item, "USER")}
                          >
                            Change to User
                          </p>
                          <p
                            className={styles.tittleTextOperation}
                            onClick={() => submitAction(item, "USER_PHYSICIAN")}
                          >
                            Change to Physician
                          </p>
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                )}
                <Grid
                  item
                  md={1}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {edit && removeId === item.id ? (
                    <Button
                      fullWidth
                      size="large"
                      onClick={() => handleCancel(item)}
                      style={{
                        fontSize: "0.9rem",
                        lineHeight: "1.25rem",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontStyle: "normal",
                        width: 100,
                        height: 35,
                        backgroundColor: "white",
                        color: "#0F9BB0",
                        textTransform: "none",
                        border: "2px solid",
                        borderColor: "#0F9BB0",
                      }}
                    >
                      Cancel
                    </Button>
                  ) : item?.role !== "SUPER_ADMIN" ? (
                    <p
                      className={styles.tittleTextOperation}
                      onClick={() => handleRemove(item)}
                    >
                      Remove
                    </p>
                  ) : null}
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "1rem" }}>
                <Grid item md={12}>
                  <hr style={{ border: "0.1px solid #A6DCE5" }} />
                </Grid>
              </Grid>
            </>
          ))}
        </Box>
        <Snackbar
          open={alert.showAlert}
          autoHideDuration={4000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert severity={alert.severity} onClose={handleClose}>
            {alert.message}
          </Alert>
        </Snackbar>
      </Grid>
    </>
  );
}
